import React, {useEffect, useState} from 'react';
import {Col, Input, Row, Table} from 'reactstrap';

const StockTransferTable = ({tableData, handleEdit, handleDelete, searchTerm, onSearch}) => {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(tableData);
  }, [tableData]);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredData(tableData);
      return;
    }
    const t = searchTerm.toLowerCase();
    setFilteredData(
      tableData.filter(
        (row) =>
          row.date?.includes(searchTerm) ||
          row.fromCurrency?.toLowerCase()?.includes(t) ||
          row.toCurrency?.toLowerCase()?.includes(t) ||
          row.stockTransferId?.toString()?.includes(searchTerm)
      )
    );
  }, [searchTerm, tableData]);

  if (!tableData || tableData.length === 0) {
    return <div className='text-center mt-5 pt-3'>No Data Available</div>;
  }

  return (
    <React.Fragment>
      <div className='mt-2'>
        <Row className='mt-2'>
          <Col sm={12}>
            <Table responsive className='table-bordered'>
              <thead>
                <tr style={{background: '#f5f6f8'}}>
                  <th>Date</th>
                  <th>From Currency</th>
                  <th>Sell Qty</th>
                  <th>To Currency</th>
                  <th>Exchange Rate</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((row) => (
                    <tr key={row.stockTransferId}>
                      <td>{row.date}</td>
                      <td>{row.fromCurrency}</td>
                      <td>{row.qty}</td>
                      <td>{row.toCurrency}</td>
                      <td>{row.convertRate}</td>
                      <td className='jornalTable'>
                        <span className='cursor text-primary' onClick={() => handleEdit(row)}>
                          <i className='bx bx-pencil font-size-18 me-1'></i>
                        </span>
                        <span className='cursor text-danger' onClick={() => handleDelete(row)}>
                          <i className='bx bx-trash-alt font-size-18'></i>
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className='text-center' colSpan={7}>
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default StockTransferTable;
